import * as ng from 'angular';

export class LdaState {
   static $inject = ['ipCookie'];

   constructor(private ipCookie) { }

   get passed () {
      return this.ipCookie('lda-passed');
   }

   set passed (val) {
      this.ipCookie('lda-passed', val, {
         expires: 30,
         expirationUnit: 'minutes'
      });
   }

   get redirect () {
      return this.ipCookie('lda-redirect');
   }

   set redirect (val) {
      this.ipCookie('lda-redirect', val, {
         expires: 1,
         expirationUnit: 'hours'
      });
   }
}

ng.module('selfReg')
   .service('ldaState', LdaState);
